import { RouterProvider, createBrowserRouter } from 'react-router';
import { routes } from '@/configs/router/routes';

export const router = createBrowserRouter(routes);

export const routerProvider = <RouterProvider router={router}></RouterProvider>;
